export interface ConfigBaseProps {}

const BaseConfig: ConfigBaseProps = {};

export default BaseConfig;
